import { createRouter, createWebHistory } from 'vue-router';
import type { SeoPageKey } from '@/data/seo';
import HomeView from '@/views/HomeView.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: { seoPage: 'home' satisfies SeoPageKey },
    },
    {
      path: '/about',
      redirect: { path: '/', hash: '#sobre-mim' },
    },
    {
      path: '/projects',
      redirect: { path: '/', hash: '#portfolio' },
    },
    {
      path: '/uses',
      redirect: { path: '/', hash: '#conhecimentos' },
    },
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return new Promise((resolve) => {
        requestAnimationFrame(() => {
          const el = document.querySelector(to.hash);
          if (!el) {
            resolve({ top: 0 });
            return;
          }
          const prefersReduced = globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;
          el.scrollIntoView({
            behavior: prefersReduced ? 'auto' : 'smooth',
            block: 'start',
          });
          resolve(false);
        });
      });
    }
    return { top: 0, left: 0 };
  },
});

export default router;
